// extracted by mini-css-extract-plugin
export default {"content":"ServicesCategoryCard_content__PyLqS","content_disabled":"ServicesCategoryCard_content_disabled__Z92i-","content__icon":"ServicesCategoryCard_content__icon__XzKuY"};